export enum StorageFileIndexStatus {
    IN_PROGRESS = 'INDEXING_IN_PROGRESS',
    COMPLETED = 'INDEXING_COMPLETED',
    FAILED = 'INDEXING_FAILED',
    UNKNOWN = 'UNKNOWN'
}
export type StorageFile = {
    id: string;
    name: string;
    type: string;
    fileExtension: string;
    updateTime: string;
    size: number;
    sizeReadable: string;
    indexStatus: StorageFileIndexStatus;
}